import React from "react";
import { IonCard } from "@ionic/react";

import { Product } from "@core/types";
import CardHeader from "./CardHeader";
import CardContent from "./CardContent";
import { WishlistButton } from "./WishlistButton";

import classNames from "classnames/bind";
import styles from "./MainPageProduct.module.scss";
import "./MainPageProduct.scss";

interface ProductCartProps {
  product: Product;
  lazyload?: boolean;
}

const cx = classNames.bind(styles);

const MainPageProduct = ({ product, lazyload }: ProductCartProps) => {
  return (
    <div className={cx("skeletonWidth", "fortime-product-component", "product")}>
      <IonCard
        title={product.name}
        className={cx(
          "ion-no-margin ion-margin-top animated fadeIn",
          "productCommon__card",
          "cardFortime",
          "cardShadow",
          "min-h-[14rem] max-h-[14rem] flex flex-col justify-between"
        )}
      >
        <CardHeader product={product} lazyload={lazyload ?? false} />
        <CardContent product={product} />
        <WishlistButton product={product} />
      </IonCard>
    </div>
  );
};

MainPageProduct.displayName = "4time_MainPageProduct";

export default MainPageProduct;
